import React, {useState, useEffect} from "react";
import styled from "styled-components"
import { useNavigate } from "react-router-dom";
import useTokenStore from "../Store/Store";
import Prev from "../../img/PrevBlack.png"
import DeleteImg from "../../img/Delete.png"
import axios from "axios";
import MenuEx from "../../img/naga.png"
import { useCookies } from 'react-cookie';
import CompanyInfo from "../MenuCompo/CompanyInfo";

const Styled={
    Wrap:styled.div`
        width:100%;
        height:100%;
        display:flex;
        justify-content:flex-start;
        align-items:center;
        flex-direction:column;
        background-color:#ffffff;
    `,
    HeaderWrap:styled.div`
        width:100%;
        height:56px;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
        position:fixed;
        z-index:3;
        background-color:#ffffff;
    `,
        Header:styled.div`
            width:90%;
            height:56px;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:row;
        `,
            PrevBtn:styled.div`
                width:24px;
                height:24px;
                &:hover{
                    cursor:pointer;
                }
            `,
                PrevImg:styled.img`
                    width:100%;
                    height:100%;
                `,
            HeaderText:styled.p`
                font-size:20px;
                font-weight:600;
                color:#000000;
                margin:0px;
                font-family:'PreFont';
            `,
        ContentBackground:styled.div`
            width:90%;
            height:auto;
            display:flex;
            justify-content:flex-start;
            align-items:center;
            flex-direction:column;
            margin-top:60px;
        `,
        EmptyContents:styled.div`
            width:100%;
            height: calc(100vh - 156px);
            display:flex;
            justify-content:center;
            align-items:center;
            flex-direction:column;
        `,
            EmptyText:styled.p`
                font-size:16px;
                font-weight:600;
                color:#919191;
                margin:0px;
                font-family:'PreFont';
            `,
            ContentBox:styled.div`
                width:100%;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:column;
                border:1px solid #EDEDED;
                border-radius:10px;
                margin-bottom:10px;
            `,
                OrderWrap:styled.div`
                    width:100%;
                    height:auto;
                    padding-left:0px;
                    padding-right:0px;
                    padding-top:16px;
                    padding-bottom:16px;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    flex-direction:row;
                `,
                OrderBox:styled.div`
                    width:90%;
                    height:auto;
                    display:flex;
                    justify-content:space-between;
                    align-items:center;
                    flex-direction:row;
                `,
                MenuImg:styled.div`
                    width:103px;
                    height:80px;
                `,
                    Img:styled.img`
                        width:100%;
                        height:100%;
                        border-radius:10px;
                        border:1px solid #787878;
                    `,
                Content:styled.div`
                    width:calc(100% - 113px);
                    height:auto;
                    display:flex;
                    justify-content:space-between;
                    align-items:center;
                    flex-direction:row;
                `,
                    LeftContent:styled.div`
                        width:65%;
                        height:100%;
                        display:flex;
                        justify-content:space-between;
                        align-items:flex-start;
                        flex-direction:column;
                    `,
                    RightContent:styled.div`
                        width:35%;
                        height:84px;
                        display:flex;
                        justify-content:space-between;
                        align-items:flex-end;
                        flex-direction:column;
                    `,
                        CancelRequestBtn:styled.div`
                            
                            z-index:3;
                            width:52px;
                            height:23px;
                            border-radius:28px;
                            border:1px solid #B7B7B7;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            flex-direction:row;
                            &:hover{
                                opacity:50%;
                                transition:0.5s;
                            }
                        `,
                            CancelRequestBtnText:styled.p`
                                font-size:11px;
                                font-weight:400;
                                margin:0px;
                                font-family:'PreFont';
                                color:#767676;
                                letter-spacing:-0.33px;
                            `,
                        NoCancelBtn:styled.div`
                            width:63px;
                            height:23px;
                            border-radius:28px;
                            border:1px solid #FF4444;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            flex-direction:row;
                        `,
                            NoCancelBtnText:styled.p`
                                font-size:11px;
                                font-weight:400;
                                margin:0px;
                                font-family:'PreFont';
                                color:#FF4444;
                                letter-spacing:-0.33px;
                            `,
                        CancelEndBtn:styled.div`
                            width:54px;
                            height:23px;
                            border-radius:28px;
                            border:1px solid #1A76FF;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            flex-direction:row;
                        `,
                            CancelEndBtnText:styled.p`
                                font-size:11px;
                                font-weight:400;
                                margin:0px;
                                font-family:'PreFont';
                                color:#1A76FF;
                                letter-spacing:-0.33px;
                            `,
                        ContentHText:styled.p`
                            font-size:16px;
                            font-weight:600;
                            margin:0px;
                            font-family:'PreFont';
                            color:#181818;
                            letter-spacing:-0.33px;
                        `,
                        ContentText:styled.p`
                            font-size:16px;
                            font-weight:400;
                            margin:0px;
                            font-family:'PreFont';
                            color:#181818;
                            letter-spacing:-0.33px;
                        `,
                        ContentGrayText:styled.p`
                            font-size:14px;
                            font-weight:400;
                            margin:0px;
                            font-family:'PreFont';
                            color:#929292;
                            letter-spacing:-0.33px;
                        `,
                        ContentDateText:styled.p`
                            font-size:13px;
                            font-weight:400;
                            margin:0px;
                            font-family:'PreFont';
                            color:#929292;
                            letter-spacing:-0.33px;
                        `,





        FooterSpace:styled.div`
            width:100px;
            height:100px;
        `,
        Footer:styled.div`
            width:100%;
            height:100px;
            display:flex;
            justify-content:center;
            align-items:flex-start;
            flex-direction:row;
            background-color:#ffffff;
            z-index:3;
            position:fixed;
            bottom:0;
            box-shadow: 0px 0px 20px #eeeeee;
        `,
            CallBtn:styled.div`
                width:90%;
                height:50px;
                border-radius:10px;
                display:flex;
                justify-content:flex-start;
                align-items:flex-start;
                flex-direction:row;
                margin-top:10px;
            `,
                BtnText:styled.p`
                    font-size:16px;
                    font-weight:700;
                    color:#111111;
                    margin:0px;
                    font-family:'PreFont';
                `,

}
const OrderList=()=>{
    const [Langcookies, setLangCookie, removeLangCookie] = useCookies(["PageLang"]);
    const [IDcookies, setIDcookies, removeIDcookies] = useCookies(["restaurant_id"]);
    const [Restaurant_PK, setRestaurant_PK] = useState(undefined)
    const [Table_PK, setTable_PK] = useState(undefined)

    const [ApiData, setApiData] = useState([])
    const navigate = useNavigate();
    
    useEffect(() => {
        if (IDcookies["restaurant_id"]) {
            const first = IDcookies["restaurant_id"].substring(0, 36);     // 앞 절반
            const second = IDcookies["restaurant_id"].substring(36);       // 뒤 절반
        
            setRestaurant_PK(first);
            setTable_PK(second);
                } else {
                    console.log("ID 값이 없습니다.");
                }
    }, [IDcookies["restaurant_id"]]);


    const axiosInstance = axios.create({
        baseURL: 'https://zzikgomainapi.co.kr/',
    });

    
    const RestaurantCheck = async () => {
        try {
            // const response = await axiosInstance.get("orders/order/?table__id="+Table_PK);
            const response = await axiosInstance.get("business/restaurant/"+Restaurant_PK);

            // business/restaurant/StoreID
            console.log(response.data.tables)
            const result = response.data.tables.find(item => item.id === Table_PK);

            console.log("선택된 테이블:", result);
            // setApiData(response.data.results)
            setApiData(result.orders)
        } catch (error) {
            console.error(error); // 요청에 실패한 경우 에러 메시지 출력
        }
    };

    useEffect(()=>{
        if(Table_PK){
            RestaurantCheck()
        }
    },[Table_PK])

    const [Title, setTitle] = useState({
        "KR":"주문내역",
        "EN":"Order history",
        "CN":"订单详情",
        "JP":"注文履歴",
        "FR":"détails de commande",
        "SP":"historial de pedidos",
        "GR":"Bestellübersicht",
        "RU":"заказ"
    })
    const [OrderQuantity, setOrderQuantity] = useState({
        "KR":"수량",
        "EN":"Quantity",
        "CN":"数量",
        "JP":"数量",
        "FR":"quantité",
        "SP":"cantidad",
        "GR":"Menge",
        "RU":"количество"
    })
    
    const [ToTal, setToTal] = useState({
        "KR":"총 주문금액",
        "EN":"Total Order Amount",
        "CN":"总订单金额",
        "JP":"総注文金額",
        "FR":"Montant total de la commande",
        "SP":"Importe total del pedido",
        "GR":"Gesamtbestellbetrag",
        "RU":"Общая сумма заказа"
    })

    const [Won, setWon] = useState({
        "KR":"원",
        "EN":"won",
        "CN":"won",
        "JP":"ウォン",
        "FR":"won",
        "SP":"won",
        "GR":"won",
        "RU":"won"
    })

    const [CancelText, setCancelText] = useState({
        "KR":"취소요청",
        "EN":"Cancel",
        "CN":"取消",
        "JP":"Cancel",
        "FR":"Cancel",
        "SP":"Cancelar",
        "GR":"Cancel",
        "RU":"Cancel"
    })

    const [NoCancelText, setNoCancelText] = useState({
        "KR":"취소거절",
        "EN":"Can`t Cancel",
        "CN":"取消拒絶",
        "JP":"Can`t Cancel",
        "FR":"Can`t Cancel",
        "SP":"Can`t Cancel",
        "GR":"Can`t Cancel",
        "RU":"Can`t Cancel"
    })
    const [CancelEndText, setCancelEndText] = useState({
        "KR":"취소완료",
        "EN":"Cancelled",
        "CN":"已取消",
        "JP":"Cancelled",
        "FR":"Cancelled",
        "SP":"Cancelled",
        "GR":"Cancelled",
        "RU":"Cancelled"
    })

    function formatDateTime(dateTimeString) {
        const date = new Date(dateTimeString);
    
        // 날짜 포맷: 두 자릿수로 맞춤
        const year = String(date.getFullYear()).slice(2); // 연도 뒤 두 자리
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 월 (0부터 시작하므로 +1)
        const day = String(date.getDate()).padStart(2, '0'); // 일
        const hours = String(date.getHours()).padStart(2, '0'); // 시간
        const minutes = String(date.getMinutes()).padStart(2, '0'); // 분
    
        return `${month}.${day} ${hours}:${minutes}`;
    }

    function sumTotalCosts(data) {
        const total = data.reduce((acc, curr) => acc + curr.total_costs, 0);
        return total.toLocaleString(); // 숫자에 천 단위 구분 쉼표 추가
    }
    useEffect(()=>{
        if(ApiData !== undefined){
            sumTotalCosts(ApiData)
        }
        
    }, [ApiData])

    function truncateText(text, maxLength = 24, sliceLength = 22) {
        if (text.length > maxLength) {
          return text.slice(0, sliceLength) + '...';
        }
        return text;
      }
    return(
            <Styled.Wrap>
                <Styled.HeaderWrap>
                    <Styled.Header>
                        <Styled.PrevBtn onClick={() => navigate(-1)}>
                            <Styled.PrevImg src={Prev}/>
                        </Styled.PrevBtn>
                        <Styled.HeaderText>{Title[Langcookies["PageLang"]]}</Styled.HeaderText>
                        <Styled.PrevBtn />
                    </Styled.Header>
                </Styled.HeaderWrap>
                <Styled.ContentBackground>
                    {ApiData.length === 0 ? 
                        <Styled.EmptyContents>
                            <Styled.EmptyText>주문 내역이 아직 없어요</Styled.EmptyText>
                        </Styled.EmptyContents>
                        :<></>
                    }
                {ApiData.map((order, orderIndex) => (
                    <Styled.ContentBox key={order.id} onClick={() => { navigate("/orderlistdetail", { state: { order }}) }}>
                        {order.items.map((item, itemIndex) => 
                        (
                            <Styled.OrderWrap>
                                <Styled.OrderBox key={item.menu}>
                                    <Styled.MenuImg>
                                        <Styled.Img src={`https://zzikgomainapi.co.kr${item.menu_info.image}`} alt={item.menu_info.names.KR} />
                                    </Styled.MenuImg>
                                    <Styled.Content>
                                        <Styled.LeftContent>
                                            <Styled.ContentHText>{truncateText(item.menu_info.names[Langcookies["PageLang"]])}</Styled.ContentHText>
                                            <Styled.ContentText>
                                                {item.menu_info.price * item.quantity}{Won[Langcookies["PageLang"]]}
                                            </Styled.ContentText>
                                            <Styled.ContentGrayText>
                                                {OrderQuantity[Langcookies["PageLang"]]} : {item.quantity}
                                            </Styled.ContentGrayText>
                                        </Styled.LeftContent>
                                        <Styled.RightContent>
                                            {/* 첫 번째 item에만 CancelRequestBtn을 표시 */}
                                            {itemIndex === 0 && (
                                                <>
                                                    {order.canceled_state === 0 && (
                                                        <Styled.CancelRequestBtn onClick={(e) => {
                                                            e.stopPropagation();
                                                            navigate("/Cancel", { state: { order }});
                                                        }}>
                                                            <Styled.CancelRequestBtnText>{CancelText[Langcookies["PageLang"]]}</Styled.CancelRequestBtnText>
                                                        </Styled.CancelRequestBtn>
                                                    )}
                                                    {order.canceled_state === 1 && (
                                                        // 취소 완료
                                                        <Styled.CancelEndBtn>
                                                            <Styled.CancelEndBtnText>{CancelEndText[Langcookies["PageLang"]]}</Styled.CancelEndBtnText>
                                                        </Styled.CancelEndBtn>
                                                    )}
                                                    {order.canceled_state === 2 && (
                                                        // 취소 거절
                                                        <Styled.NoCancelBtn>
                                                            <Styled.NoCancelBtnText>{NoCancelText[Langcookies["PageLang"]]}</Styled.NoCancelBtnText>
                                                        </Styled.NoCancelBtn>
                                                    )}
                                                </>

                                            )}

                                            {/* 마지막 item에만 ContentDateText를 표시 */}
                                            {itemIndex !== 0 && (
                                                <Styled.ContentDateText>
                                                </Styled.ContentDateText>
                                            )}
                                            {itemIndex === order.items.length - 1 && (
                                                <Styled.ContentDateText>
                                                    {formatDateTime(order.ordered_at) || "No Date"} {/* ordered_at이 없으면 기본 텍스트 표시 */}
                                                </Styled.ContentDateText>
                                            )}
                                        </Styled.RightContent>
                                    </Styled.Content>
                                </Styled.OrderBox>
                            </Styled.OrderWrap>
                            
                        ))}
                    </Styled.ContentBox>
                ))}
                    <CompanyInfo />
                </Styled.ContentBackground>
                <Styled.FooterSpace />
                <Styled.Footer>
                    <Styled.CallBtn>
                        <Styled.BtnText>{ApiData === undefined ? "로딩중": `${ToTal[Langcookies["PageLang"]]} : ${sumTotalCosts(ApiData)}${Won[Langcookies["PageLang"]]}`}</Styled.BtnText>
                    </Styled.CallBtn>
                </Styled.Footer>
            </Styled.Wrap>
    )
    
}
export default OrderList